
const EnvironmentsHelp = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Endpoint Monitoring
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          The Endpoints page provides operational monitoring and health tracking for all connected AWS
          accounts and endpoints. Monitor uptime, track incidents, manage cross-account access, and
          ensure reliable operations across your multi-account AWS infrastructure.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Endpoint Overview
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          View and manage all connected accounts and endpoints.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Account List:</strong> All connected AWS accounts with details</li>
          <li><strong>Endpoint Types:</strong> Development, Staging, Production classifications</li>
          <li><strong>Account Status:</strong> Active, inactive, or pending connection status</li>
          <li><strong>Region Distribution:</strong> Primary regions for each endpoint</li>
          <li><strong>Cross-Account Roles:</strong> IAM role configuration for access</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Health Monitoring
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Track the operational health and availability of your AWS endpoints.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Health Score:</strong> Aggregated health metric per endpoint</li>
          <li><strong>Uptime Tracking:</strong> Availability percentage and uptime history</li>
          <li><strong>Service Status:</strong> Health of critical services within each account</li>
          <li><strong>Health Checks:</strong> Automated monitoring of resources and services</li>
          <li><strong>Incident Detection:</strong> Automatic alerts for service degradations</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Access Management
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Configure and manage cross-account access and permissions.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>IAM Role Configuration:</strong> Set up cross-account assume role access</li>
          <li><strong>User Access Stats:</strong> Track who has access to which endpoints</li>
          <li><strong>Permission Policies:</strong> Define and manage access policies</li>
          <li><strong>MFA Requirements:</strong> Enforce multi-factor authentication</li>
          <li><strong>Access Logs:</strong> Audit trail of cross-account access</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Incident Management
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Track and resolve operational incidents across endpoints.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Active Incidents:</strong> Current issues affecting endpoint health</li>
          <li><strong>Incident Timeline:</strong> Chronological view of past incidents</li>
          <li><strong>Severity Levels:</strong> Critical, High, Medium, Low priority classification</li>
          <li><strong>Resolution Tracking:</strong> Monitor progress on incident remediation</li>
          <li><strong>Root Cause Analysis:</strong> Document causes and preventive measures</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Performance Metrics
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Monitor key performance indicators for each endpoint.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Response Times:</strong> Average latency for services in each endpoint</li>
          <li><strong>Error Rates:</strong> Application and service error percentages</li>
          <li><strong>Resource Utilization:</strong> CPU, memory, storage usage metrics</li>
          <li><strong>Throughput:</strong> Request volume and processing capacity</li>
          <li><strong>SLA Compliance:</strong> Service level agreement adherence tracking</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Endpoint Configuration
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Configure and manage endpoint settings and properties.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Endpoint Details:</strong> Name, type, description, and metadata</li>
          <li><strong>Monitoring Settings:</strong> Configure health check intervals and thresholds</li>
          <li><strong>Notification Rules:</strong> Set up alerts for endpoint events</li>
          <li><strong>Tags & Labels:</strong> Organize endpoints with custom tags</li>
          <li><strong>Integration Settings:</strong> Connect to monitoring and logging tools</li>
        </ul>
      </div>

    </>
  );
};

export default EnvironmentsHelp;
